import { ReactNode } from 'react'
import Dropzone, { Accept } from 'react-dropzone'
import { Box } from '@mui/material'

interface Props {
  children: ReactNode
  onDrop: (acceptedFiles: File[]) => void
  accept?: Accept
  disabled?: boolean
}

const DropzoneBox = ({ children, onDrop, accept, disabled = false }: Props) => {
  return (
    <Dropzone onDrop={onDrop} noClick accept={accept} disabled={disabled}>
      {({ getRootProps, getInputProps, isDragAccept, isDragReject }) => (
        <Box
          {...getRootProps()}
          sx={{
            backgroundColor: isDragAccept ? '#b8d3ff' : isDragReject ? '#ffc0b8' : undefined,
            borderRadius: 5,
          }}
        >
          <input {...getInputProps()} />

          {children}
        </Box>
      )}
    </Dropzone>
  )
}

export default DropzoneBox
